<template>
<div v-if="!isMobile">
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
  </nav>        
    
 <v-container fluid grid-list-md>
    <v-layout row wrap>
      
      <v-col md="4">
        <v-card>
          <v-btn-toggle
        dense
        mandatory
        dark
        shaped
      >
        <v-btn v-for="item in boardName" style="font-size:11px;"
        :key="item._id">
       {{item.boardName}}
        </v-btn>
      </v-btn-toggle>
          <v-card-title style="font-size:12px">Current Usage By Phase</v-card-title>
         
          <v-card-text><span style="font-size:11px;color:red">From {{formatDate(lastMonthStart).substring(0,2)}} - {{formatDate(lastMonthEnd).substring(0,11)}} (Last Month)</span><apexchart width="300" height="150" :options="kwhP1ChartLast" :series="kwhP1SeriesLast"></apexchart></v-card-text>
          <v-card-text><span style="font-size:11px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span><apexchart width="300" height="150" :options="kwhP1ChartThis" :series="kwhP1SeriesThis"></apexchart></v-card-text>
        </v-card>
      </v-col>

       
      <v-col md="4">
        <v-card>
          <v-card-text><span style="font-size:11px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span><apexchart width="380" height="210" :options="ampP2Chart" :series="ampP2Series"></apexchart></v-card-text>
           <v-card-text><span style="font-size:11px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span><apexchart width="380" height="210" :options="ampP3Chart" :series="ampP3Series"></apexchart></v-card-text>
        </v-card>

      </v-col>

<v-col md="4">
        <v-card>
  <v-card-title style="font-size:12px"><v-icon color="cyan">mdi-weather-windy</v-icon>Air Quality Monitoring(Max Value)</v-card-title>
  <span style="font-size:11px;padding-left:5px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span>
    <v-simple-table id="mytable">
    <template v-slot:default>
      <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Location
          </th>
          <th class="text-left" style="font-size:11px">
            CO2 Level
          </th>
          <th class="text-left" style="font-size:11px">
            Ambient Temperature
          </th>
          <th class="text-left" style="font-size:11px">
            Ambient Temperature
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in airQuality"
          :key="item._id">
          <td style="font-size:11px">{{item.location[0].location}}</td>
          <td style="font-size:11px">{{item.co2}} ppm</td>
          <td style="font-size:11px">{{item.temp}} °C</td>
          <td style="font-size:11px">{{item.humid}} %RH</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
 </v-card>
</v-col>
     
    </v-layout>
  </v-container>


  <v-container fluid grid-list-md>
    <v-layout row wrap>

      <v-col md="5">
      <v-card max-width="500">
      <v-card-title style="font-size:12px"><v-icon color="orange">mdi-lightning-bolt</v-icon>Top 3 Total MCB Current Usage</v-card-title>
      <span style="font-size:11px;padding-left:5px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span>
 <v-simple-table id="mytable">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="font-size:11px">
           #
          </th>
          <th class="text-left" style="font-size:11px">
            DB Name
          </th>
          <th class="text-left" style="font-size:11px">
            MCB Label
          </th>
          <th class="text-left" style="font-size:11px">
            Current Used
          </th>
          <th class="text-left" style="font-size:11px">
            Location
          </th>
          <th class="text-left" style="font-size:11px">
            Load Types
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="font-size:11px">1</td>
          <td style="font-size:11px">{{totalBoard[0]._id.boardName}}</td>
          <td style="font-size:11px">{{totalBoard[0]._id.ryb.label}}</td>
          <td style="font-size:11px">{{totalBoard[0].value}}<span style="font-size: 9px;">A</span></td>
          <td style="font-size:11px">{{totalBoard[0].location[0].location}}</td>
          <td style="font-size:11px">{{totalBoard[0]._id.loadType.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
        <tr>
          <td style="font-size:11px">2</td>
          <td style="font-size:11px">{{totalBoard[1]._id.boardName}}</td>
          <td style="font-size:11px">{{totalBoard[1]._id.ryb.label}}</td>
          <td style="font-size:11px">{{totalBoard[1].value}}<span style="font-size: 9px;">A</span></td>
          <td style="font-size:11px">{{totalBoard[1].location[0].location}}</td>
          <td style="font-size:11px">{{totalBoard[1]._id.loadType.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
        <tr>
          <td style="font-size:11px">3</td>
          <td style="font-size:11px">{{totalBoard[2]._id.boardName}}</td>
          <td style="font-size:11px">{{totalBoard[2]._id.ryb.label}}</td>
          <td style="font-size:11px">{{totalBoard[2].value}}<span style="font-size: 9px;">A</span></td>
          <td style="font-size:11px">{{totalBoard[2].location[0].location}}</td>
          <td style="font-size:11px">{{totalBoard[2]._id.loadType.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>   
      </v-col>

    <v-col md="5">
             <v-card max-width="500">
      <v-card-title style="font-size:12px"><v-icon color="orange">mdi-lightning-bolt</v-icon>Top 3 Peak MCB Current Usage</v-card-title>
      <span style="font-size:11px;padding-left:5px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span>
 <v-simple-table id="mytable">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="font-size:11px">
           #
          </th>
          <th class="text-left" style="font-size:11px">
            DB Name
          </th>
          <th class="text-left" style="font-size:11px">
            MCB Label
          </th>
          <th class="text-left" style="font-size:11px">
            Current Used
          </th>
          <th class="text-left" style="font-size:11px">
            Location
          </th>
          <th class="text-left" style="font-size:11px">
            Load Types
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="font-size:11px">1</td>
          <td style="font-size:11px">{{maxBoard[0]._id.boardName}}</td>
          <td style="font-size:11px">{{maxBoard[0]._id.ryb.label}}</td>
          <td style="font-size:11px">{{maxBoard[0].value}}<span style="font-size: 9px;">A</span></td>
          <td style="font-size:11px">{{maxBoard[0].location[0].location}}</td>
          <td style="font-size:11px">{{maxBoard[0]._id.loadType.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
        <tr>
          <td style="font-size:11px">2</td>
          <td style="font-size:11px">{{maxBoard[1]._id.boardName}}</td>
          <td style="font-size:11px">{{maxBoard[1]._id.ryb.label}}</td>
          <td style="font-size:11px">{{maxBoard[1].value}}<span style="font-size: 9px;">A</span></td>
          <td style="font-size:11px">{{maxBoard[1].location[0].location}}</td>
          <td style="font-size:11px">{{maxBoard[1]._id.loadType.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
        <tr>
          <td style="font-size:11px">3</td>
          <td style="font-size:11px">{{maxBoard[2]._id.boardName}}</td>
          <td style="font-size:11px">{{maxBoard[2]._id.ryb.label}}</td>
          <td style="font-size:11px">{{maxBoard[2].value}}<span style="font-size: 9px;">A</span></td>
          <td style="font-size:11px">{{maxBoard[2].location[0].location}}</td>
          <td style="font-size:11px">{{maxBoard[2]._id.loadType.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>    
    </v-col>

  <v-col md="5">
       <v-card max-width="500">
      <v-card-title style="font-size:12px"><v-icon color="blue">mdi-water</v-icon>Top 3 Water Usage</v-card-title>
      <span style="font-size:11px;padding-left:5px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span>
 <v-simple-table id="mytable">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="font-size:11px">
           #
          </th>
          <th class="text-left" style="font-size:11px">
            Location
          </th>
          <th class="text-left" style="font-size:11px">
            Sensor Label
          </th>
          <th class="text-left" style="font-size:11px">
            Current Used
          </th>
          <th class="text-left" style="font-size:11px">
            Outlet Types
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="font-size:11px">1</td>
          <td style="font-size:11px">{{top3WaterFlow[0]._id.location}}</td>
          <td style="font-size:11px">{{top3WaterFlow[0]._id.waterSensor}}</td>
          <td style="font-size:11px">{{(top3WaterFlow[0].value/1000).toFixed(0)}}<span style="font-size:9px;color:black;"> m3</span></td>
          <td style="font-size:11px">{{top3WaterFlow[0]._id.outletType.map(({item}) => item).join(' + ')}}</td>
        </tr>
        <tr>
          <td style="font-size:11px">2</td>
          <td style="font-size:11px">{{top3WaterFlow[1]._id.location}}</td>
          <td style="font-size:11px">{{top3WaterFlow[1]._id.waterSensor}}</td>
          <td style="font-size:11px">{{(top3WaterFlow[1].value/1000).toFixed(0)}}<span style="font-size:9px;color:black;"> m3</span></td>
          <td style="font-size:11px">{{top3WaterFlow[1]._id.outletType.map(({item}) => item).join(' + ')}}</td>
        </tr>
        <tr>
          <td style="font-size:11px">3</td>
          <td style="font-size:11px">{{top3WaterFlow[2]._id.location}}</td>
          <td style="font-size:11px">{{top3WaterFlow[2]._id.waterSensor}}</td>
          <td style="font-size:11px">{{(top3WaterFlow[2].value/1000).toFixed(0)}}<span style="font-size:9px;color:black;"> m3</span></td>
          <td style="font-size:11px">{{top3WaterFlow[2]._id.outletType.map(({item}) => item).join(' + ')}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>   
  </v-col> 

    </v-layout>
  </v-container>

  <v-container fluid grid-list-md>
    <v-layout row wrap>

      <v-col md="2">
      <v-card max-height="100">
  <v-card-title style="font-size:12px;"><span>Water Flow Monitoring</span><v-icon color="blue">mdi-water-pump</v-icon> </v-card-title>
   <v-sheet
   class="mx-auto text-center"
      color="cyan"
    >
    <v-card-text>
      <div style="font-size:12px;color:white">
        From {{formatDate(lastMonthStart).substring(0,2)}} - {{formatDate(lastMonthEnd).substring(0,11)}} (Last Month)
      </div>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="lastWaterFlow.length == 0">
       0<span style="font-size:15px;color:black;"> m3</span>
      </div>
      <div style="font-size:18px;color:black;" v-else>
       {{(lastWaterFlow[0].total/1000).toFixed(0)}}<span style="font-size:15px;color:black;"> m3</span>
      </div>
    </v-card-text>
    </v-sheet>
    
<v-sheet
      color="cyan"
      class="mx-auto text-center"
    >
    <v-card-text>
      <div style="font-size:12px;color:white;">
        From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)
      </div>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="monthWaterFlow.length == 0">
       0<span style="font-size:15px;color:black;"> m3</span>
      </div>
      <div style="font-size:18px;color:black;" v-else>
       {{(monthWaterFlow[0].total/1000).toFixed(0)}}<span style="font-size:15px;color:black;"> m3</span>
      </div>
    </v-card-text>
  
    </v-sheet>
 
</v-card>
      </v-col>

<v-col md="3">
        <v-card>
  <v-card-title style="font-size:12px"><v-icon color="blue">mdi-cup-water</v-icon>Rain Water Harvesting Monitoring</v-card-title>
  <span style="font-size:11px;padding-left:5px;color:red">From {{formatDate(thisMonthStart).substring(0,2)}} - {{formatDate(thisMonthEnd).substring(0,11)}} (This Month)</span>
    <v-simple-table id="tankTable">
    <template v-slot:default>
      <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Water Tank Level Sensor
          </th>
          <th class="text-left" style="font-size:11px">
            {{waterTank[0].tags.waterTankConsole}}
          </th>
        </tr>
      </thead>
      <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Tank Water Level Console
          </th>
          <th class="text-left" style="font-size:11px">
            {{waterTank[0].tags.waterTankSensor}}
          </th>
        </tr>
      </thead>
       <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Rain Water Harvesting Location
          </th>
          <th class="text-left" style="font-size:11px">
            {{waterTank[0].tags.locationRemarks}}
          </th>
        </tr>
      </thead>
      <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Water Level Currently
          </th>
          <th class="text-left" style="font-size:11px">
            {{waterConv[0]}}mm
          </th>
        </tr>
      </thead>
      <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Rainwater Consumed
          </th>
          <th class="text-left" style="font-size:11px">
            {{ Math.abs(negativeSum) }}mm
          </th>
        </tr>
      </thead>
      <thead>
       <tr>
           <th class="text-left" style="font-size:11px">
            Rainwater Collected
          </th>
          <th class="text-left" style="font-size:11px">
            {{ positiveSum }}mm
          </th>
        </tr>
      </thead>
    </template>
  </v-simple-table>
 </v-card>
</v-col>
     
    </v-layout>
  </v-container>
</div>

<div v-else>
<v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 12px;">{{ formatDate(values1) }} - {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
  </v-container>

  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title primary class="title">Usage By Phase</v-card-title>
          <v-card-text><apexchart width="350" height="200" :options="kwhP1Chart" :series="kwhP1Series"></apexchart></v-card-text>
        </v-card>
      </v-col>
 
        <v-col>
        <v-card>
          <v-card-title primary class="title">Usage By Location</v-card-title>
          <v-card-text><apexchart width="380" height="500" :options="ampP2Chart" :series="ampP2Series"></apexchart></v-card-text>
        </v-card>
        </v-col>

        <v-col>
        <v-card>
          <v-card-title primary class="title">Usage By Load Types</v-card-title>
          <v-card-text><apexchart width="380" height="500" :options="ampP3Chart" :series="ampP3Series"></apexchart></v-card-text>
        </v-card>
        </v-col>
    </v-row>

  </v-container>
</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts'

Vue.component("apexchart", VueApexCharts);

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: true,
          href: '/',
        }
      ],
    values1: moment().subtract(24, "hour"),
    values2: moment().endOf("day"),
    lastMonthStart: moment().subtract(1, "month").startOf("month").startOf('day'),
    lastMonthEnd: moment().subtract(1, "month").endOf("day"),
    thisMonthStart: moment().startOf("month").startOf('day'),
    thisMonthEnd: moment().endOf('day'),
    isMobile: true,
    loading: true,
    boardName: [],
    totalBoard: [],
    maxBoard: [],
    location: [],
    locationTankItem: [],
    locationTank: [],
    loadType: [],
    boardItem: [],
    airQuality: [],
    lastWaterFlow: [],
    monthWaterFlow: [],
    top3WaterFlow: [],
    waterTank: [],
    waterLevel: [],
    waterSub: [],
    waterPercent: [],
    waterVol: [],

      kwhP1ChartLast: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        plotOptions: {
          bar: {
            distributed: true, 
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
       colors: ["#ff0303", "#f6fa16", "#0339ff"],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: ['R', 'Y', 'B']
        },
        legend: {
        show: false
        },
        yaxis: {
         labels: {
            formatter: (val) => { return val+'kW' },
      },
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val + " kWh"
            }
          }
        }
      },
      kwhP1SeriesLast: [
       {
          data: []
        }
      ],

      kwhP1ChartThis: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
         animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        plotOptions: {
          bar: {
            distributed: true, 
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
       colors: ["#ff0303", "#f6fa16", "#0339ff"],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: ['R', 'Y', 'B']
        },
        legend: {
        show: false
        },
        yaxis: {
         labels: {
            formatter: (val) => { return val+'kW' },
      },
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val + " kWh"
            }
          }
        }
      },
      kwhP1SeriesThis: [
       {
          data: []
        }
      ],

      ampP2Chart: {
       chart: {
          type: 'pie',
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        labels: [],
         tooltip: {
          y: {
            formatter: function (val) {
              return  val + "A"
            }
          }
        },
        legend: {
              position: 'right'
            },
            title: {
            text: 'Current Usage By Location',
            align: 'left',
            floating: false,
            style: {
            fontSize:  '11px',
            fontWeight:  'bold',
            
          },
      }
      },
      ampP2Series: [],

      ampP3Chart: {
       chart: {
          type: 'pie',
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        labels: [],
         tooltip: {
          y: {
            formatter: function (val) {
              return  val + "A"
            }
          }
        },
        legend: {
              position: 'right'
            },
        title: {
            text: 'Current Usage By Appliances',
            align: 'left',
            floating: false,
            style: {
            fontSize:  '11px',
            fontWeight:  'bold',
          },
        }
      },
      ampP3Series: []
  }),
  mounted() {
    this.loadsLocation();
    this.loadsLocationWaterTank();
    this.loadsLoadType();
    this.loadsBoardName();
    this.loadsMaxBoard();
    this.loadsTotalBoard();
    this.loadsLastMonth();
    this.loadsThisMonth();
    this.loadsMaxFlowLast();
    this.loadsMaxFlowThis();
    this.loadsMaxFlowTop3();
    this.loadsCO2();
    this.loadsWaterTank();
    this.onResize();
    this.intervalFetchData();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    intervalFetchData: function () {
    setInterval(() => {    
    this.loadsMaxBoard(),
    this.loadsTotalBoard(),
    this.loadsLastMonth(),
    this.loadsThisMonth(),
    this.loadsMaxFlowLast(),
    this.loadsMaxFlowThis(),
    this.loadsMaxFlowTop3(),
    this.loadsCO2(),
    this.loadsWaterTank()
       }, 60000); 
    },
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
    formatDate(value) {
      return moment(value).format("DD MMM YYYY, h:mm:ss a")
    },
  loadsLastMonth: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/cms/"+ this.boardItem + "/" + this.lastMonthStart.toDate() + '/'+ this.lastMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.kw1Last = res.data.map((kw) => kw.fields.p_phase1);
    this.kw2Last = res.data.map((kw) => kw.fields.p_phase2);
    this.kw3Last = res.data.map((kw) => kw.fields.p_phase3);

    this.kwhP1SeriesLast = [
            {
              name:'Max',
              data: [Math.max(...this.kw1Last),Math.max(...this.kw2Last),Math.max(...this.kw3Last)]
            },
          ];

    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsThisMonth: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/cms/"+ this.boardItem + "/" + this.thisMonthStart.toDate() + '/'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.kw1This = res.data.map((kw) => kw.fields.p_phase1);
    this.kw2This = res.data.map((kw) => kw.fields.p_phase2);
    this.kw3This = res.data.map((kw) => kw.fields.p_phase3);

    this.kwhP1SeriesThis = [
            {
              name:'Max',
              data: [Math.max(...this.kw1This),Math.max(...this.kw2This),Math.max(...this.kw3This)]
            },
          ];

    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsLocation: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/ecms/"+ "count-location" + "/" + this.thisMonthStart.toDate() + '-'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.location = res.data;
     for (let i = 0; i < res.data.length; i++) {
        this.ampP2Series.push(res.data[i].value);
        this.ampP2Chart.labels.push(res.data[i].result[0].location);
      }

    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsBoardName: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/single-phase";
      axios.get(apiURL).then(res => {
      this.boardName = res.data;
      this.boardItem = this.boardName[0].boardName;
      this.loadsLastMonth();
      this.loadsThisMonth();
      }).catch(error => {
      console.log(error)
      }).finally(() => this.loading = false);
},
  loadsLoadType: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/ecms/"+ "count-load-type" + "/" + this.thisMonthStart.toDate() + '-'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.loadType = res.data;
     for (let i = 0; i < res.data.length; i++) {
        this.ampP3Series.push(res.data[i].value);
        this.ampP3Chart.labels.push(res.data[i]._id);
      }

    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsTotalBoard: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/ecms/total/" + this.thisMonthStart.toDate() + '-'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.totalBoard = res.data;
    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsMaxBoard: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/ecms/max/" + this.thisMonthStart.toDate() + '-'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.maxBoard = res.data;
    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsMaxFlowLast: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-flow/max/" + this.lastMonthStart.toDate() + '-'+ this.lastMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.lastWaterFlow = res.data;
    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsMaxFlowThis: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-flow/max/" + this.thisMonthStart.toDate() + '-'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.monthWaterFlow = res.data;
    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsMaxFlowTop3: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-flow/top3/" + this.thisMonthStart.toDate() + '-'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.top3WaterFlow = res.data;
    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
  loadsCO2: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/air-quality/" + "aq" + "/" + this.thisMonthStart.toDate() + '/'+ this.thisMonthEnd.toDate();
  axios.get(apiURL).then(res => {
    this.airQuality = res.data;
  }).catch(error => {
    console.log(error)
  }).finally(() => this.loading = false);
  },
  loadsWaterTank: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-tank/"+ this.locationTankItem + "/" + this.thisMonthStart.toDate() + '/'+ this.thisMonthEnd.toDate();
    axios.get(apiURL).then(res => {
    this.waterTank = res.data;
    this.waterLevel = res.data.map((water) => water.fields.water_level);
    this.waterConv = this.waterLevel.map((x) => 2057 - x); 
    this.waterSub = this.waterConv.slice(1).map((v, i) => v - this.waterConv[i]);
    this.waterPercent = this.waterConv.map((x) => (x / 2057) * 100);
    this.waterVol = this.waterConv.map((x) => (x * 1220 * 3660) / 1000000);
    this.positive = this.waterSub.filter(posNumber => posNumber >= 0);
    this.negative = this.waterSub.filter(negNumber => negNumber < 0);
    this.positiveSum = this.positive.reduce((sumSoFar, current) => sumSoFar + current, 0);
    this.negativeSum = this.negative.reduce((sumSoFar, current) => sumSoFar + current, 0);
    }).catch(error => {
    console.log(error)
    });
  },
  loadsLocationWaterTank: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/location-water-tank";
      axios.get(apiURL).then(res => {
      this.locationTank = res.data;
      this.locationTankItem = this.locationTank[0]._id;
      this.loadsWaterTank();
      }).catch(error => {
      console.log(error)
      });
    },
  updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsBoard();
      this.loadsLocation();
      this.ampP2Series.splice(values,this.location.length);
      this.ampP2Chart.labels.splice(values,this.location.length);
      this.loadsLoadType();
      this.ampP3Series.splice(values,this.loadType.length);
      this.ampP3Chart.labels.splice(values,this.loadType.length);
      this.loadsTotalBoard();
      this.loadsMaxBoard();
      this.loadsMaxFlowLast();
      this.loadsMaxFlowThis();
      this.loading = true;
    },
    updateBoard(){
      this.loadsBoard();
      this.loading = true;
    },
    updateLocationTank(){
      this.loadsWaterTank();
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
}
</script>
<style scoped>

#mytable table thead tr th {
  background: rgba(138, 131, 131, 0.348);
}

#tankTable table thead tr th:nth-child(1)  {
  background: rgba(0, 0, 255, 0.708);
  color: rgb(255, 255, 255);
}

#tankTable table thead tr th  {
  border: 2px groove;
}

</style>